<template>
  <div class="div-category-selectables-base">
    <div class="div-category-selectables-heading">
      <div class="div-category-selectables-icon">
        <img
          id="img-category-selectables-content"
          src="@/assets/docrates-icon-imaging.svg"
        />
      </div>
      <h2
        id="category-selectables-h2"
        v-html="
          store.getters.translate(
            'category-services-appointment-imaging-heading'
          )
        "
      ></h2>
    </div>
    <div class="div-category-selectables-content">
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="mammography"
        :heading="
          store.getters.translate('category-service-card-mammography-heading')
        "
        :text-1="
          store.getters.translate('category-service-card-mammography-text-1')
        "
        :text-1link="
          store.getters.translate(
            'category-service-card-mammography-text-1-link'
          )
        "
        :text-1b="
          store.getters.translate('category-service-card-mammography-text-1b')
        "
      ></category-service-card>
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="ct-scan"
        :heading="
          store.getters.translate('category-service-card-ct-scan-heading')
        "
        :text-bold="
          store.getters.translate('category-service-card-ct-scan-text-bold')
        "
        :text-1="
          store.getters.translate('category-service-card-ct-scan-text-1')
        "
        :text-2="
          store.getters.translate('category-service-card-ct-scan-text-2')
        "
      ></category-service-card>
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="mri-scan"
        :heading="
          store.getters.translate('category-service-card-mri-scan-heading')
        "
        :text-bold="
          store.getters.translate('category-service-card-mri-scan-text-bold')
        "
        :text-1="
          store.getters.translate('category-service-card-mri-scan-text-1')
        "
        :text-2="
          store.getters.translate('category-service-card-mri-scan-text-2')
        "
        :text-3="
          store.getters.translate('category-service-card-mri-scan-text-3')
        "
      ></category-service-card>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { index } from "@/store/index";
import CategoryServiceCard from "@/components/CategoryServiceCard.vue";
import { getServiceTypeFromString } from "@/store/appointment-selection";

export default defineComponent({
  components: { CategoryServiceCard },
  name: "CategoryServiceImaging",
  emits: ["serviceSelected"],
  data() {
    return {
      store: index
    };
  },
  methods: {
    serviceSelectedInComponent(selectedServiceType: string) {
      this.$emit(
        "serviceSelected",
        getServiceTypeFromString(selectedServiceType)
      );
    }
  }
});
</script>

<style scoped lang="scss">
.div-category-selectables-icon {
  padding-left: 14px;
  padding-top: 16px;
  position: static;
  width: 60px;
  height: 60px;
  border: 1px solid $original;
  box-sizing: border-box;
  border-radius: 161px;
  margin-right: 20px;
  min-width: 60px;
}
h2 {
  margin-top: 10px;
}
// This will change with new Category
// and when more than 1 imaging service.
@media (min-width: 1061px) {
  .div-category-selectables-base {
    width: 944px;
  }
}
</style>
